module.exports = __webpack_public_path__ + "media/images/views/lp/recruiter/choose-sourcedout/high-earnings-awaits-78ad09061c5e9dd18340bf9a57a4a5ef.png";